export const ROUTES = {
    login: '/',
    unauthorized: '/unauthorized',
    demo: '/demo',
    analytics: '/analytics',
};
